import { z } from "zod";

// ==================
// User Schemas
// ==================

/**
 * Basic user information returned in auth responses
 */
export const AuthUserSchema = z.object({
  id: z.number(),
  email: z.string().email(),
  first_name: z.string(),
  last_name: z.string(),
});

export type AuthUser = z.infer<typeof AuthUserSchema>;

// ==================
// User Type
// ==================

/**
 * User type: "client" or "expert"
 */
export const UserTypeSchema = z.enum(["client", "expert"]);
export type UserType = z.infer<typeof UserTypeSchema>;

// ==================
// Client Schemas
// ==================

/**
 * Client information returned in auth check response
 */
export const AuthClientSchema = z.object({
  id: z.number(),
  company_name: z.string(),
  profile_picture: z.string().nullable().optional(),
});

export type AuthClient = z.infer<typeof AuthClientSchema>;

// ==================
// Organization Schemas
// ==================

/**
 * Organization information returned in auth check response for clients
 */
export const AuthOrganizationSchema = z.object({
  id: z.number(),
  name: z.string(),
  role: z.string(),
});

export type AuthOrganization = z.infer<typeof AuthOrganizationSchema>;

// ==================
// Expert Schemas
// ==================

/**
 * Expert status values
 */
export const ExpertStatusSchema = z.enum(["draft", "published", "unpublished", "pending"]);
export type ExpertStatus = z.infer<typeof ExpertStatusSchema>;

/**
 * Expert information returned in auth check response
 */
export const AuthExpertSchema = z.object({
  id: z.number(),
  slug: z.string(),
  status: ExpertStatusSchema,
  profile_picture: z.string().nullable().optional(),
});

export type AuthExpert = z.infer<typeof AuthExpertSchema>;

